<template>
    <a href="#" class="header__links__item  btn  btn--primary  btn--icon  btn--icon--primary" @click="open">
        <i class="fas fa-search"></i>
        <span>{{ __('Search') }}</span>
    </a>
</template>

<script>
    export default {
        name: 'search-trigger',

        methods: {
            open() {
                event.preventDefault();

                this.$root.search.opened = !this.$root.search.opened;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/SearchTrigger.vue